export const MenuAdminBisnis = [
	{
		path: '/dashboard',
		icon: 'desktop',
		title: 'Dashboard',
		type: 'link'
	},
	{ 	
		path: '/main/list-desa',
		icon: 'list', 
		title: 'List Desa', 
		type: 'link' 
	},
	{ 
		path: '/main/request-surat', 
		icon: 'files',
		title: 'Request Surat', 
		type: 'link' 
	},
	{
		title: 'Digidesa Landing',
		icon: 'server',
		type: 'sub',
		active: false,
		children: [
			{ path: '/main/bumdes', title: 'Data Bumdes', type: 'link' },
			{ path: '/main/partner', title: 'Data Partner', type: 'link' },
			{ path: '/main/daftar-desa', title: 'Daftar Desa', type: 'link' },
			{ path: '/main/data-klik', title: 'Data Klik', type: 'link' },
		]
	},
];
